import { createContext } from 'react';
import { Config } from '../../models/config';

export type GetServiceFn = <T>(token: symbol | Function, createService: (config: Config) => T) => T;

export const ServicesContainerContext = createContext<GetServiceFn | undefined>(undefined);
